module.exports = __webpack_public_path__ + "static/ig_banner_05-0199d79c490ea4454fa2b1bd74e6fdf8.png";